export type LastCartIdSyncResult =
  | { shouldSync: false }
  | { shouldSync: true; cartId: string | null };

type ResolveLastCartIdSyncParams = {
  cartId?: string | null;
  hasItems: boolean;
  cartIdChanged: boolean;
  syncedCartId: string | null;
};

/*
 Determines whether and how to synchronize buyer.lastCartId with the cart.
 */
export const resolveLastCartIdSync = ({
  cartId,
  hasItems,
  cartIdChanged,
  syncedCartId,
}: ResolveLastCartIdSyncParams): LastCartIdSyncResult => {
  if (cartId && hasItems) {
    if (cartId === syncedCartId) {
      return { shouldSync: false };
    }
    return { shouldSync: true, cartId };
  }

  if (cartId && !cartIdChanged && syncedCartId === cartId) {
    return { shouldSync: true, cartId: null };
  }

  return { shouldSync: false };
};
